import { Typography, useMediaQuery } from '@mui/material';
import React from 'react';

const RemoveAccount = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  return (
    <div style={{ margin: isMobile ? '0 5% 0 10% ' : '0 0 0 15%' }}>
      <Typography
        style={{ color: 'white', fontFamily: 'baloo2', fontSize: isMobile ? '28px' : '48px', fontWeight: '700' }}>
        How to Delete Your Account
      </Typography>
      <Typography style={{ color: 'white', fontFamily: 'baloo2', fontSize: isMobile ? '21px' : '32px' }}>
        If you no longer wish to use your account, you can delete it permanently.
      </Typography>
      <Typography style={{ color: 'white', fontFamily: 'baloo2', fontSize: isMobile ? '18px' : '26px' }}>
        Follow the steps below to delete your account from the mobile app:
      </Typography>
      <ul style={{ color: 'white', fontFamily: 'baloo2', fontSize: isMobile ? '18px' : '26px', paddingBottom: '20%' }}>
        <li>
          1. Open the <strong>Champsverse</strong> App on your device.
        </li>
        <li>
          2. <strong>Login</strong> with your credentials.
        </li>
        <li>
          3. Go to the <strong>Settings</strong> section.
        </li>
        <li>
          4. Select <strong>Setting & Privacy</strong>{' '}
        </li>
        <li>
          5. Select <strong>Delete Account</strong>{' '}
        </li>
        <li>
          6. Confirm your action by tapping <strong>Proceed</strong>{' '}
        </li>
        <li>
          7. Verfiy your account by entering <strong>OTP</strong>
        </li>
        <li>
          8. Your Account will be <strong>Deteled successfully</strong>
        </li>
      </ul>
    </div>
  );
};
export default RemoveAccount;
